import Categories from './Categories';
import Category from './Category';
import Item from './Item';
import React from 'react';
import { Route, Switch } from 'react-router-dom';

export default function Shop({ match }) {
  return (
    <Switch>
      <Route path={match.path} component={Categories} exact />
      <Route path={`${match.path}/category/:id`} component={Category} />
      <Route path={`${match.path}/item/:id`} component={Item} />
    </Switch>
  );
}



// WEBPACK FOOTER //
// ./src/views/shop/components/Shop.jsx